export default __webpack_public_path__ + "static/media/book_shelf_hero.c1bba0fa.png";